const WISP_BASE_URL = "https://www.wisp.blog";
const WISP_API_VERSION = "v1";
const FALLBACK_BLOG_ID = "cm8o0a2ws00005p1xcslfk444";

export const WISP_SETUP_URL = "https://www.wisp.blog/app/setup/existing-website";

const WISP_BLOG_ID =
  process.env.REACT_APP_WISP_BLOG_ID || FALLBACK_BLOG_ID;

/** Base URL for post collection and single-post fetches (`${base}/${slug}`). */
export const WISP_POSTS_API_ENDPOINT = `${WISP_BASE_URL}/api/${WISP_API_VERSION}/${WISP_BLOG_ID}/posts`;

/**
 * Blog index: fetch every post (list payload has no bodies). Must match the
 * build (`limit=all`) so /blog/page/N lists the same posts as the prerender.
 */
export const WISP_POSTS_LIST_LIMIT = "all";
export const WISP_POSTS_LIST_URL = `${WISP_POSTS_API_ENDPOINT}?limit=${WISP_POSTS_LIST_LIMIT}`;

/** ISO string for when the post was published (WISP may use camelCase or snake_case). */
export const getPostPublishedAt = (p) =>
  p?.publishedAt || p?.published_at || p?.createdAt || null;

/** Locale-formatted date for UI, or null if missing/invalid. */
export const formatBlogPublishedDate = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
